import { register } from 'ol/proj/proj4.js';
import { get as getProjection } from 'ol/proj.js';
import proj4 from 'proj4';
import type { Projection } from 'ol/proj.js';
import {
  defineSjtskProjection,
  EPSG_5514,
  EPSG_5514_DEF,
  sjtskToWgs84,
  wgs84ToSjtsk,
  type SjtskPoint,
  type Wgs84Point,
} from '@reos/geo-input';

/**
 * Krok M1 — S-JTSK / Krovak East North (EPSG:5514) v OpenLayers.
 *
 * MapLibre 5514 neumi (proto OpenLayers, ROZHODNUTI briefu); OL potrebuje
 * proj4 definici, protoze 5514 neni v jeho vestavenem seznamu.
 *
 * Krok GPS1: definice 5514 a samotne prevody si ted PREVZALO `@reos/geo-input`
 * (dalsi konzument — sdileny parser, ktery prevadi S-JTSK vstupni retezec na
 * bod). Tady zustala jen OL registrace, kterou zadani GPS1 nemeni. Dve
 * definice 5514 v repu by se casem rozchazily a mapa v adminu by ukazala
 * jinou parcelu nez veejny web — proto je definice jen jedna.
 */
export { EPSG_5514, sjtskToWgs84, wgs84ToSjtsk };
export type { SjtskPoint, Wgs84Point };

let registered = false;

/** Idempotentni - volatelna z kazde komponenty, která mapu pouziva. */
export function registerSjtskProjection(): Projection {
  if (!registered) {
    defineSjtskProjection();
    register(proj4);
    registered = true;
  }
  const projection = getProjection(EPSG_5514);
  if (projection === null) throw new Error('parcel-map-crs: registrace EPSG:5514 selhala');
  return projection;
}

/** Definice je v `@reos/geo-input`; re-export ji, aby zde zustal jediny import. */
export { EPSG_5514_DEF };
